import { render, staticRenderFns } from "./ProductsInStockLocationsOrder.vue?vue&type=template&id=72de2606&scoped=true"
import script from "./ProductsInStockLocationsOrder.vue?vue&type=script&lang=js"
export * from "./ProductsInStockLocationsOrder.vue?vue&type=script&lang=js"
import style0 from "./ProductsInStockLocationsOrder.vue?vue&type=style&index=0&id=72de2606&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72de2606",
  null
  
)

export default component.exports